import strengths from "./strength/reducer";
import slumps from "./slump/reducer";
import distances from "./distance/reducer";
import structures from "./structure/reducer";
import producttypes from "./product-type/reducer";
import pricelists from "./pricelist/reducer";
import vehicletypeconfig from "./vehicletype-config/reducer";
import products from "./product/reducer";
import plantProducts from "./plant-product/reducer";

const productMangement = {
  strengths,
  slumps,
  distances,
  structures,
  producttypes,
  pricelists,
  vehicletypeconfig,
  mdProducts: products,
  plantProducts,
};

export default productMangement;
